import { isNil } from 'lodash';
import { Condition } from '@upstart/harmony/lib/constants';
import { BackendService } from './BackendService';
import { Car } from '../types/carTypes';

export class CarService {
  static async getCarDetails(carId: string) {
    return BackendService.get<Car>(`/cars/${carId}`);
  }

  static async getSampleCar(
    dealerId: string,
    stock?: string,
    condition?: string,
  ): Promise<{ error?: string; car?: Car }> {
    const cars = await BackendService.get<Car[]>('/cars/filter/cards', {
      params: {
        dealer: dealerId,
        ...(stock && { stock }),
        ...(condition && { condition: [condition] }),
      },
    });
    const firstCar = cars.data?.[0];

    if (!firstCar) {
      if (stock) {
        // We were given a specific stock, but no car was found
        return { error: 'Stock provided not found' };
      }
      // We were trying to get any cars, but none was returned
      return { error: 'No cars found' };
    }

    // Try and pick any car with image if stock not provided, otherwise just return first result
    if (!stock) {
      const anyNewCarWithImage = cars.data?.find(
        (car) => car.carImg && car.condition === Condition.NEW && car.price,
      );
      const anyCarWithImage = cars.data?.find((car) => car.carImg && car.price);
      const anyCarWithPrice = cars.data?.find((car) => car.price);
      // Prefer new cars with image, then cars with image, then just any car with price
      const car = anyNewCarWithImage || anyCarWithImage || anyCarWithPrice;
      if (!car) {
        return { error: 'No cars with price found' };
      }

      // suplement the car object with incentive details
      // not ideal as we are making double requests
      const carDetail = await CarService.getCarDetails(car.id);
      return { car: carDetail.data };
    }

    // Otherwise it's a stock that was requested
    // Check if car actually has a price
    if (isNil(firstCar.price)) {
      return { error: 'Stock provided does not have a price set' };
    }

    // We need to car incentive offers which can be retrieved from <backend>/car/<id> endpoint
    const carDetail = await CarService.getCarDetails(firstCar.id);

    return { car: carDetail.data };
  }
}
